import { lazy } from "react";

export const FaqAsync = lazy(()=> import('./Faq'))
